import { getCustDoor, getLinkConfig } from '@/api/doorControl'

const state = {
	linkConfig: {}
}
const mutations = {
	setLinkConfig (state, preload) {
		state.linkConfig = preload
	}
}

const actions = {
	getCustDoor ({}, data) {
		return new Promise((resolve, reject) => {
			getCustDoor(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getLinkConfig ({ state, commit }) {
		if (Object.keys(state.linkConfig).length) return
		return new Promise((resolve, reject) => {
			getLinkConfig()
				.then((res) => {
					commit('setLinkConfig', res)
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
